import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { IMarketingDocument } from 'src/app/core/models/masters/marketing-document.model';
import { GlobalProperties } from 'src/app/global/global-properties';
import { enumMarketingDocumentList, enumMarketingDocumentType, enumMarketingDocumentTypeCode } from 'src/app/infrastructure/infrastructure-services/common/common-enums';
import { WrapperStandardFilter, WrapperStandardRequest } from 'src/app/infrastructure/infrastructure-services/common/models/wrapper.model';
//import { IMarketingDocument } from 'src/app/core/models/masters/marketing-document.model';
import { GenericListView } from 'src/app/infrastructure/infrastructure-services/generics/genericlistview/generic-list-view';
import { BaseService } from 'src/app/infrastructure/infrastructure-services/services/base/base-service';
import { GenericService } from 'src/app/infrastructure/infrastructure-services/services/base/generic-service';
import { ReportViewPopupComponent } from 'src/app/shared/report-view-popup/report-view-popup.component';
import { environment } from 'src/environments/environment.dev';
import { SecurityService } from 'src/app/login-layout/Service/security.service';

@Component({
  selector: 'app-marketing-document-list-view',
  templateUrl: './marketing-document-list-view.component.html',
  styleUrls: ['./marketing-document-list-view.component.css']
})
export class MarketingDocumentListViewComponent extends GenericListView<IMarketingDocument> {
  apiString: any;
  FilterRequestData: any[] = [];
  printFormats: any[] = [];
  documentType: number = 0;

  canAdd: boolean = true;
  canEdit: boolean = true;
  canView: boolean = true;
  isActiveMenu: boolean = true;

  checkMenuPermissions() {
    let securityService = new SecurityService();
    let permissions = securityService.getMenuPermissions(this.getFormSubTitle);

    this.canAdd = permissions.canAdd;
    this.canEdit = permissions.canEdit;
    this.canView = permissions.canView;
    this.isActiveMenu = permissions.isActive;
  }

  constructor(agenericRepository: GenericService<IMarketingDocument>, router: Router, public snackbarService: BaseService<any>,
    public dialog: MatDialog, private activated: ActivatedRoute, private http: HttpClient,
    private baseService: BaseService<any>) {
    super(agenericRepository, router);

    this.activated.url.subscribe(data => {

      if (data[0].path == enumMarketingDocumentList.SalesQutationList) {
        this.setFormTitle = "Sales";
        this.apiString = 'Quotations/GetQuotationsListService';
        this.documentType = enumMarketingDocumentTypeCode.SalesQutation;
      }
      else if (data[0].path == enumMarketingDocumentList.SalesOrderList) {
        this.setFormTitle = "Sales";
        this.apiString = 'Orders/GetOrdersListService';
        this.documentType = enumMarketingDocumentTypeCode.SalesOrder;
      }
      else if (data[0].path == enumMarketingDocumentList.SalesInvoiceList) {
        this.setFormTitle = "Sales";
        this.apiString = 'Invoices/GetInvoicesListService'
        this.documentType = enumMarketingDocumentTypeCode.SalesInvoice;
      }
      else if (data[0].path == enumMarketingDocumentList.ARDownPaymentRequestList) {
        this.setFormTitle = "Sales";
        this.apiString = 'ARDownPaymentRequest/GetARDownPaymentRequestListService'
        this.documentType = enumMarketingDocumentTypeCode.ARDownPaymentRequest;
      }

      else if (data[0].path == enumMarketingDocumentList.PurchaseOrderList) {
        this.setFormTitle = "Purchase";
        this.apiString = 'PurchaseOrders/GetPurchaseOrdersListService'
        this.documentType = enumMarketingDocumentTypeCode.PurchaseOrder;
      }

      else if (data[0].path == enumMarketingDocumentList.PurchaseQutationList) {
        this.setFormTitle = "Purchase";
        this.apiString = 'PurchaseQuotations/GetPurchaseQuotationsListService'
        this.documentType = enumMarketingDocumentTypeCode.PurchaseQutation;
      }

      else if (data[0].path == enumMarketingDocumentList.PurchaseInvoiceList) {
        this.setFormTitle = "Purchase";
        this.apiString = 'PurchaseInvoices/GetPurchaseInvoicesListService'
        this.documentType = enumMarketingDocumentTypeCode.PurchaseInvoice;
      }

      else if (data[0].path == enumMarketingDocumentList.APDownPaymentRequestList) {
        this.setFormTitle = "Purchase";
        this.apiString = 'APDownPaymentRequest/GetAPDownPaymentRequestListService'
        this.documentType = enumMarketingDocumentTypeCode.APDownPaymentRequest;
      }

      else if (data[0].path == enumMarketingDocumentList.GRPOList) {
        this.setFormTitle = "Purchase";
        this.apiString = 'GRPO/GetGRPOListService'
        this.documentType = enumMarketingDocumentTypeCode.GRPO;
      }
      else if (data[0].path == enumMarketingDocumentList.DeleveryChalanList) {
        this.apiString = 'DeliveryNotes/GetDeliveryNotesListService'
        // this.documentType = enumMarketingDocumentTypeCode.DeleveryChalan;
      }
      else if (data[0].path == 'DebitNotesListView') {
        this.apiString = 'DebitNotes/GetDebitNotesListService'
        this.documentType = enumMarketingDocumentTypeCode.DebitNotes;
      }


      else if (data[0].path == enumMarketingDocumentList.CreditNotes) {
        this.setFormTitle = "Sales";
        this.apiString = 'CreditNotes/GetCreditNotesListService'
        this.documentType = enumMarketingDocumentTypeCode.CreditNotes;
      }

      else if (data[0].path == enumMarketingDocumentList.DebitNotes) {
        this.setFormTitle = "Purchase";
        this.apiString = 'DebitNotes/GetDebitNotesListService'
        this.documentType = enumMarketingDocumentTypeCode.DebitNotes;
      }
      else if (data[0].path == enumMarketingDocumentList.PickLists) {
        this.setFormTitle = "Pick Lists";
        this.apiString = 'PickList/GetPickListListService'
      }
      else if (data[0].path == enumMarketingDocumentList.PurchaseRequestList) {
        this.setFormTitle = "Purchase";
        this.apiString = 'PurchaseRequest/GetPurchaseRequestListService'
        this.documentType = enumMarketingDocumentTypeCode.PurchaseRequest;
      }

      setTimeout(() => {
        this.checkMenuPermissions();
      }, 100);
    });
    this.setObjectType = this.activated.snapshot.data['ObjType'];

    if (this.getObjectType == enumMarketingDocumentType.SalesOrder) {
      this.setFormSubTitle = 'Sales Orders';
      this.setEntryFormRouteTo = "/home/sales/salesOrderEntryForm/";
    }
    else if (this.getObjectType == enumMarketingDocumentType.SalesQutation) {
      this.setFormSubTitle = 'Sales Quotations';
      this.setEntryFormRouteTo = "/home/sales/salesQutationEntryForm/";
    }
    else if (this.getObjectType == enumMarketingDocumentType.ARDownPaymentRequest) {
      this.setFormSubTitle = 'Sales Down Payment Request';
      this.setEntryFormRouteTo = "/home/sales/salesDownPaymentRequestEntryForm/";
    }
    else if (this.getObjectType == enumMarketingDocumentType.SalesInvoice) {
      this.setFormSubTitle = 'Sales Invoice';
      this.setEntryFormRouteTo = "/home/sales/salesInvoiceEntryForm/";
    }
    else if (this.getObjectType == enumMarketingDocumentType.CreditNotes) {
      this.setFormSubTitle = 'Credit Notes';
      this.setEntryFormRouteTo = "/home/sales/creditNotesEntryForm/";
    }
    else if (this.getObjectType == enumMarketingDocumentType.DebitNotes) {
      this.setFormSubTitle = 'Debit Notes';
      this.setEntryFormRouteTo = "/home/sales/debitNotesEntryForm/";
    }
    else if (this.getObjectType == enumMarketingDocumentType.PurchaseOrder) {
      this.setFormSubTitle = 'Purchase Order'
      this.setEntryFormRouteTo = "/home/sales/purchaseOrderEntryForm/";
    }

    else if (this.getObjectType == enumMarketingDocumentType.PurchaseQutation) {
      this.setEntryFormRouteTo = "/home/sales/purchaseQutationEntryForm/";
      this.setFormSubTitle = 'Purchase Quotation'
    }

    else if (this.getObjectType == enumMarketingDocumentType.DebitNotes) {
      this.setFormTitle = 'Debit Notes'
    }
    else if (this.getObjectType == enumMarketingDocumentType.DeleveryChalan) {
      this.setEntryFormRouteTo = "/home/sales/deliveryChallanEntryForm/";
      this.setFormSubTitle = 'Delivery Challan'
    }
    else if (this.getObjectType == enumMarketingDocumentType.APDownPaymentRequest) {
      this.setEntryFormRouteTo = "/home/sales/purchaseDownPaymentRequestentryform/";
      this.setFormSubTitle = 'Purchase Down Payment Request'
    }
    else if (this.getObjectType == enumMarketingDocumentType.ARDownPaymentRequest) {
      this.setFormSubTitle = 'Sales Down Payment Request'
    }

    else if (this.getObjectType == enumMarketingDocumentType.GRPO) {
      this.setFormSubTitle = 'GRPO'
      this.setEntryFormRouteTo = "/home/sales/GRPOEntryForm/";
    }
    else if (this.getObjectType == enumMarketingDocumentType.CreditNotes) {
      this.setFormSubTitle = 'Credit Notes'
    }
    else if (this.getObjectType == enumMarketingDocumentType.DebitNotes) {
      this.setFormSubTitle = 'Debit Notes'
    }
    else if (this.getObjectType == enumMarketingDocumentType.PurchaseInvoice) {
      this.setEntryFormRouteTo = "/home/sales/purchaseInvoiceEntryForm/";
      this.setFormSubTitle = 'Purchase Invoice'
    }
    else if (this.getObjectType == enumMarketingDocumentType.PickLists) {
      this.setEntryFormRouteTo = "/home/sales/pickListsEntryForm/";
      this.setFormSubTitle = 'Pick Lists'
    }
    else if (this.getObjectType == enumMarketingDocumentType.PurchaseRequest) {
      this.setEntryFormRouteTo = "/home/sales/purchaseRequestEntryForm/";
      this.setFormSubTitle = 'Purchase Request'
    }

    this.setMenuCode = "";

    this.setListViewDataSourceURL = `${this.apiString}`;
    this.setDisplayedColumnsNamesList = ['docNum', 'cardCode', 'cardName', 'branchName', 'salesPersonCodeName', 'docDate', 'documentStatusName', 'action'];

    if (this.getFormSubTitle == "Pick Lists") {
      this.setDisplayedColumnsNamesList = ['absoluteentry', 'orderEntry', 'pickDate', 'remarks', 'action'];

      this.getRequestData.SortColumn = 'pickDate';
      var filter: WrapperStandardFilter = new WrapperStandardFilter();
      filter.Key = 'baseObjectType';
      filter.OperatorType = null;
      filter.Value = "17"
      this.FilterRequestData.push(filter);
      this.getRequestData.RequestData = this.FilterRequestData;
    }
    else { this.getRequestData.SortColumn = 'docDate'; }
    this.getRequestData.IsAcending = false;
    this.PopulateListView();

    //this.gateWayLogin(); 
    this.getAvailablePrintFormats();
  }


  printDocument(docEntry: number, formatCode: string) {
    // const exportDataPayload = [
    //   {
    //       "name": "DocKey@",
    //       "type": "xsd:decimal",
    //       "value": [
    //           [
    //               docEntry
    //           ]
    //       ]
    //   },
    //   {
    //       "name": "ObjectID@",
    //       "type": "xsd:decimal",
    //       "value": [
    //           [
    //               this.documentType
    //           ]
    //       ]
    //   },
    //   {
    //       "name": "Schema@",
    //       "type": "xsd:string",
    //       "value": [
    //           [
    //               GlobalProperties._companyDb
    //           ]
    //       ]
    //   }
    // ]

    const payload = new WrapperStandardRequest();
    let sapInfo: any = GlobalProperties.getSapInfo;
    payload.RequestData = {
      "loginURL": `${sapInfo.GateWayApiURL}login`,
      "apiGatewayURL": `${sapInfo.GateWayApiURL}rs/v1/ExportPDFData?DocCode=`,
      "sapUserName": sapInfo.GateWayUserId,
      "password": sapInfo.GateWayPassword,
      "companyDB": sapInfo.CompanyDB,
      "dbInstance": sapInfo.DbInstance,
      "docCode": formatCode,
      "docEntry": docEntry,
      "objType": this.documentType,
      "userName": null
    }



    this.snackbarService.PostAPI(GlobalProperties.getApiUrl + 'SAPReportGateway/GetSAPReport', payload).subscribe(res => {

      this.showReportPopup(res.responseData);

    })

    //  console.log('payload',payload)

    //  payload.RequestData={...moreProperty};
    // this.http.post(`${environment._gateWayAPIUrl}rs/v1/ExportPDFData?DocCode=${formatCode}`, 
    //   exportDataPayload, { responseType: 'text' }).subscribe({
    //     next: (response) => {
    //       this.showReportPopup(response)
    //     },
    //     error: () => {
    //       this.baseService.showMessage('Something Went Wrong', 'X');
    //     }
    //   })
  }




  gateWayLogin() {
    const loginPayload = {
      "CompanyDB": "INT_WMSDEVSAPHANA",
      "UserName": "UTL0792",
      "DBInstance": "NDB@192.168.2.188:30013",
      "Password": "Utl@0792"
    }
    this.http.post(`${environment._gateWayAPIUrl}login`, loginPayload).subscribe();
  }

  getAvailablePrintFormats() {
    const printFormatPayload = new WrapperStandardRequest();
    printFormatPayload.RequestData = this.documentType.toString();
    this.baseService.PostAPI(GlobalProperties.getApiUrl + 'PrintFormat/GetPrintFormatService', printFormatPayload).subscribe(res => {
      this.printFormats = res?.responseData?.availableFormats;
    })
  }

  showReportPopup(responseData: string) {
    this.dialog.open(ReportViewPopupComponent, {
      width: '1400px',
      height: '800px',
      data: {
        reportData: responseData
      }
    });
  }
}
